'use strict';

import config from 'config';
import React, { Component } from 'react';
import zChat from 'vendor/web-sdk';

const { LABELS } = config;

class ChatRating extends Component {
  constructor(props) {
    super(props);

    this.rateBadButtonOnClick = this.rateBadButtonOnClick.bind(this);
    this.rateGoodButtonOnClick = this.rateGoodButtonOnClick.bind(this);
    this.rateAgainButtonOnClick = this.rateAgainButtonOnClick.bind(this);
  }

  rateBadButtonOnClick() {
    zChat.sendChatRating('bad');
  }

  rateGoodButtonOnClick() {
    zChat.sendChatRating('good');
  }

  rateAgainButtonOnClick() {
    zChat.sendChatRating(null);
  }

  render() {
    if (this.props.shouldDisplay === false) {
      return null;
    }

    this.rateGood = this.props.hasRating && 'good' === this.props.rate ? this.rateAgainButtonOnClick : this.rateGoodButtonOnClick;
    this.rateBad = this.props.hasRating && 'bad' === this.props.rate ? this.rateAgainButtonOnClick : this.rateBadButtonOnClick;

    const ratedGoodClasses = 'action-button button button-rate button-rate-good ' + ( this.props.hasRating && 'good' === this.props.rate ? 'active' : '' );
    const ratedBadClasses = 'action-button button button-rate button-rate-bad ' + ( this.props.hasRating && 'bad' === this.props.rate ? 'active' : '' );

    return (
      <div className="chat-rating">
        {this.props.title}
        <div className="buttons-container">
          <button className={ratedGoodClasses} title={LABELS.rate_good_button || 'Rate good'} onClick={this.rateGood}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
              <path d="M18.75,8.59374999 L16.40625,8.59374999 L16.40625,3.90624997 C16.40625,2.61183259 15.3569174,1.56249997 14.0625,1.56249997 L13.75,1.56249997 C12.6729211,1.56333251 11.7350612,2.29815062 11.4765625,3.34374997 L9.91406249,7.64062498 C9.71368857,8.20100978 9.1887216,8.57998002 8.59374999,8.59374999 L2.34374997,8.59374999 L2.34374997,22.65625 L18.75,22.65625 C20.9073623,22.65625 22.65625,20.9073623 22.65625,18.75 L22.65625,12.5 C22.65625,10.3426377 20.9073623,8.59374999 18.75,8.59374999 Z M7.03124998,21.09375 L3.90624997,21.09375 L3.90624997,10.15625 L7.03124998,10.15625 L7.03124998,21.09375 Z M21.09375,18.75 C21.09375,20.0444174 20.0444174,21.09375 18.75,21.09375 L8.59374999,21.09375 L8.59374999,10.15625 C9.86083789,10.1563233 10.9905971,9.35829395 11.4140625,8.16406249 L12.9765625,3.82812497 L12.9765625,3.73437497 C13.0584017,3.37097452 13.385422,3.11589869 13.7578125,3.12499997 L14.0625,3.12499997 C14.4939725,3.12499997 14.84375,3.47477751 14.84375,3.90624997 L14.84375,10.15625 L18.75,10.15625 C20.0444174,10.15625 21.09375,11.2055826 21.09375,12.5 L21.09375,18.75 Z" fill="currentColor"></path>
            </svg>
            {LABELS.rate_good_button || 'Rate good'}
          </button>
          <button className={ratedBadClasses} title={LABELS.rate_bad_button || 'Rate bad'} onClick={this.rateBad}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path d="M17.1875,2.34374997 L6.24999998,2.34374997 C4.09263767,2.34374997 2.34374997,4.09263767 2.34374997,6.24999998 L2.34374997,12.5 C2.34374997,14.6573623 4.09263767,16.40625 6.24999998,16.40625 L8.59374999,16.40625 L8.59374999,21.09375 C8.59374999,22.3881674 9.64308261,23.4375 10.9375,23.4375 L11.25,23.4375 C12.3270789,23.4366675 13.2649388,22.7018494 13.5234375,21.65625 L15.0859375,17.359375 C15.2863114,16.7989902 15.8112784,16.42002 16.40625,16.40625 L22.65625,16.40625 L22.65625,2.34374997 L17.1875,2.34374997 Z M13.5859375,16.8359375 L12.0234375,21.171875 L12.0234375,21.265625 C11.9415983,21.6290255 11.614578,21.8841013 11.2421875,21.875 L10.9375,21.875 C10.5060275,21.875 10.15625,21.5252225 10.15625,21.09375 L10.15625,14.84375 L6.24999998,14.84375 C4.95558259,14.84375 3.90624997,13.7944174 3.90624997,12.5 L3.90624997,6.24999998 C3.90624997,4.95558259 4.95558259,3.90624997 6.24999998,3.90624997 L16.40625,3.90624997 L16.40625,14.84375 C15.1391621,14.8436767 14.0094029,15.641706 13.5859375,16.8359375 L13.5859375,16.8359375 Z M21.09375,14.84375 L17.96875,14.84375 L17.96875,3.90624997 L21.09375,3.90624997 L21.09375,14.84375 Z" fill="currentColor"></path>
            </svg>
            {LABELS.rate_bad_button || 'Rate bad'}
          </button>
        </div>
      </div>
    );
  }
}


ChatRating.displayName = 'ChatRating';
ChatRating.propTypes = {
  agent: React.PropTypes.object,
  hasRating: React.PropTypes.oneOfType([
    React.PropTypes.string,
    React.PropTypes.bool
  ]),
  shouldDisplay: React.PropTypes.bool
};
ChatRating.defaultProps = {
  hasRating: null,
  rate: false,
  shouldDisplay: true
};

export default ChatRating;



// WEBPACK FOOTER //
// ./src/components/ChatRating.js